import { create } from "zustand";

type DrawerStore = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export const useDrawerStore = create<DrawerStore>((set) => ({
  isOpen: false,
  setIsOpen: (isOpen) => set({ isOpen }),
}));
